import React from "react";
import Opportunity from "../Opportunity";
import "./recommendations.css";

const Recommendations = ({ oppArr }) => {
  if (!oppArr || oppArr.length === 0) {
    return (
      <div className="no-opportunities-container">
        <h2>No Opportunities Found</h2>
        <p>
          We couldn't find any personalized opportunities for you at the moment.
        </p>
        <p>
          Try completing your profile or check back later for more
          recommendations.
        </p>
      </div>
    );
  }

  return (
    <div className="recommendations-container">
      {oppArr.map((opp, index) => (
        <Opportunity
          key={`opp-${index}-${opp.title}`}
          name={opp.title}
          info={opp.description}
          stipend={opp.application_deadline}
          location={opp.location}
          typeofopportunity={opp.typeofopportunity}
          eligiblity={opp.eligibility}
          is_opguru_recommended={opp.is_opguru_recommended}
        />
      ))}
    </div>
  );
};

export default Recommendations;
